import { render, staticRenderFns } from "./trunk-select.vue?vue&type=template&id=1d6de541&"
import script from "./trunk-select.vue?vue&type=script&lang=js&"
export * from "./trunk-select.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports